import { MenuIcon } from 'lucide-react';
import { NavLink } from 'react-router';
import { FUEL_TYPE_OPTION } from '@/shared/consts';
import { Circle } from '@/shared/ui';

type MapSearchBarProps = {
	onSelectFuelType: (
		fuelType: (typeof FUEL_TYPE_OPTION)[number]['value'],
	) => void;
	selectedFuelType: (typeof FUEL_TYPE_OPTION)[number]['value'];
};

const MapSearchBar = ({
	onSelectFuelType,
	selectedFuelType,
}: MapSearchBarProps) => {
	return (
		<div className="absolute top-5 right-5 left-5 z-10">
			<NavLink
				to="/search"
				className="flex h-14 items-center rounded-lg bg-white px-4 shadow-[0px_5px_40px_0px_rgba(0,0,0,0.1)]"
			>
				<p className="flex-1 text-start font-inter text-[#969696]">
					어디서 주유할까요?
				</p>
				<MenuIcon />
			</NavLink>
			<div className="mt-3 flex gap-3">
				<button
					type="button"
					className={`flex h-11 cursor-pointer items-center gap-2 rounded-full border bg-mantang-white px-4 font-medium text-sm drop-shadow-[0px_5px_40px_0px_rgba(0,0,0,0.1)] ${selectedFuelType === FUEL_TYPE_OPTION[0].value ? 'border-mantang-primary' : 'border-transparent'}`}
					onClick={() => onSelectFuelType(FUEL_TYPE_OPTION[0].value)}
				>
					<Circle className="h-6 w-6 bg-mantang-bg-yellow text-mantang-primary text-xs">
						G
					</Circle>
					{FUEL_TYPE_OPTION[0].label}
				</button>
				<button
					type="button"
					className={`flex h-11 cursor-pointer items-center gap-2 rounded-full border bg-mantang-white px-4 font-medium text-sm drop-shadow-[0px_5px_40px_0px_rgba(0,0,0,0.1)] ${selectedFuelType === FUEL_TYPE_OPTION[1].value ? 'border-mantang-red' : 'border-transparent'}`}
					onClick={() => onSelectFuelType(FUEL_TYPE_OPTION[1].value)}
				>
					<Circle className="h-6 w-6 bg-mantang-bg-red text-mantang-red text-xs">
						D
					</Circle>
					{FUEL_TYPE_OPTION[1].label}
				</button>
			</div>
		</div>
	);
};

export default MapSearchBar;
